/**
 * User: herbert
 * Date: 14.02.16
 * Time: 18:05
 *
 *
 */

import Reflux from 'reflux';

import finishActions from '../actions/finish-actions.js';
import steleActions from '../../stele/actions/stele-actions.js';
//import stepActions from '../../slxstep/actions/step-actions.js';

import finishConfig from '../../../config-finish.js';

export default Reflux.createStore({
	init: function() {
		this.listenToMany(finishActions);
		this.state = {
			selected: finishConfig[0],
			applied: finishConfig[0]
		};
	},
	onSelect: function(f) {
		this.state.selected = f;
		this.output();
	},
	onApply: function() {
		this.state.applied = this.state.selected;
		this.output();
		steleActions.setFinish(this.state.selected.color);
		//stepActions.switchSubStep(null);
	},
	output: function() {
		this.trigger(this.getInitialState());
	},
	getInitialState: function() {
		return this.state;
	}
});
